import { inject, Injectable } from "@angular/core";
import { WidgetType } from "clearline-common";
import { AdvancedAccountSetupGateService } from "./advanced-account-setup-gate.service";

export interface MarketingAppGatedFeature {
  widgetType: WidgetType;
  name: string;
  iconUrl?: string;
  open: () => void;
}

@Injectable({ providedIn: "root" })
export class MarketingAppAccountGateService {
  private readonly gateService = inject(AdvancedAccountSetupGateService);

  open({ widgetType, name, iconUrl, open }: MarketingAppGatedFeature): void {
    this.gateService.open({ kind: "marketingApp", widgetType }, { name, iconUrl, open });
  }
}
